import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import { AdsManagerForBank } from 'src/ads/AdsManagerForBank'
import bank from 'src/assets/images/jar_img.png'
import { CustomButton, CustomLink, Icon, Timer } from 'src/components/ui'
import { BottleType } from 'src/pages/Bottle/Bottles.types'
import { sendingRequestToJoinBottle } from 'src/pages/Bottle/utils/sendingRequestToJoinBottle'
import { calculateCountdown } from 'src/utils/calculateCountdown'
import { formattedText } from 'src/utils/formattedText'

import styles from './LotteryBottle.module.scss'
import { ModalDailyLottery } from './components'

interface Props extends BottleType {}

const LotteryBottle: React.FC<Props> = (bottle) => {
  const { t } = useTranslation()

  const [isActiveModal, setIsActiveModal] = useState<boolean>(false)

  const { total_stars, participants_count, available_until, start_date, id: bottleId, participant_users } = bottle
  const { time } = calculateCountdown(available_until || '00:00:00', start_date)

  const navigate = useNavigate()

  const changeActiveModal = () => {
    setIsActiveModal((prevState) => !prevState)
  }

  const numberAdsViewedOnHour = Number(localStorage.getItem('numberAdsViewedOnHour'))

  const showAd = async () => {
    try {
      const success = await AdsManagerForBank.Instance.showAd_Rewarded_Intestitial()

      if (success) {
        console.log('ad is success')

        const numberAdsViewedOnDay = Number(localStorage.getItem('numberAdsViewedOnDay'))
        const numberAdsToTickets = Number(localStorage.getItem('numberAdsToTickets'))
        const numberAdsViewedOnHour = Number(localStorage.getItem('numberAdsViewedOnHour'))

        localStorage.setItem('numberAdsViewedOnHour', String(numberAdsViewedOnHour - 1))
        localStorage.setItem('numberAdsViewedOnDay', String(numberAdsViewedOnDay - 1))
        localStorage.setItem('numberAdsToTickets', String(numberAdsToTickets + 1))

        if (bottleId) await sendingRequestToJoinBottle(bottleId, 'ADS', 1)

        navigate('/')
      } else {
        throw Error
      }
    } catch (error) {
      alert('No ads available.')
    }
  }

  return (
    <>
      <div className={styles.bottle}>
        <div className={styles.header}>
          <div className={styles.top}>
            <button onClick={changeActiveModal}>
              <Icon name='tooltip' />
            </button>
            <p>{t('main_bottle_item.daily_lottery')}</p>
          </div>

          <div className={styles.tabs}>
            <CustomLink to={`/bottles/${bottleId}/attachment`} variant='contained' color='white'>
              Telegram Stars
            </CustomLink>

            <CustomButton
              variant={numberAdsViewedOnHour <= 0 ? 'not-active' : 'outlined'}
              color='white'
              onClick={showAd}
            >
              {t('main_bottle_item.viewing_ads')}
            </CustomButton>
          </div>
        </div>

        <hr className={styles.line} />

        <Link to={`/bottles/${bottleId}`} className={styles.info}>
          <img src={bank} alt='Bank with money' />

          <div className={styles.list}>
            <div className={styles.item}>
              <p className={styles.title}>{t('main_bottle_item.collected')}</p>
              <div>
                <Icon name='star_in_main_bottle' />
                <p>{formattedText(Math.abs(total_stars || 0))}</p>
              </div>
            </div>
            <div className={styles.item}>
              <p className={styles.title}>{t('main_bottle_item.to_end')}</p>
              <div>
                <Timer icon='timer_in_main' time={time} variant='time' className={styles.timer} />
              </div>
            </div>
            <div className={styles.item}>
              <p className={styles.title}>{t('main_bottle_item.participants')}</p>
              <div>
                <Icon name='participants_in_main_bottle' />
                <p>{formattedText(participants_count || 0)}</p>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <ModalDailyLottery
        isActiveModal={isActiveModal}
        changeActiveModal={changeActiveModal}
        participant_users={participant_users}
      />
    </>
  )
}

export default LotteryBottle
